export default __webpack_public_path__ + "static/media/sad.2aae28b3.gif";